module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Cardboard-vr-3c75737d567716c1eae131a4f11764cb.svg";